/**
 * Represents a horizontal toolbar that centers items vertically.
 */
export class ToolbarCustomElement
{
}
